import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsLaptop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 26.665H1.52v-3.05H0v4.57h1.52v1.53h28.95v-1.53H32v-4.57h-1.53z\"/><path fill=\"currentColor\" d=\"M28.95 20.565h1.52v3.05h-1.52Zm-10.67-9.14h1.53v1.52h-1.53Zm-4.57 12.19h4.57v1.52h-4.57Zm1.53-12.19h1.52v1.52h-1.52Zm-3.05 0h1.52v1.52h-1.52Zm-7.62-9.14h22.86v1.52H4.57Z\"/><path fill=\"currentColor\" d=\"M28.95 20.565V3.805h-1.52v15.24H4.57V3.805H3.05v16.76zm-27.43 0h1.53v3.05H1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsLaptop
